import { OutletState } from '.';
import { OutletListingItem } from './types';

const getOutletListing = (state: OutletState): OutletListingItem[] => state.getOutletListing || [];

export default {
    getOutletListing,
};
